<template>
  <div id="app">
    <RouterView></RouterView>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // Leaflet 地图已通过 CDN 引入，无需额外初始化
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111823;
  height: 100%;
  line-height: 1.5;
  background-color: white;
}
</style>
